import { render, staticRenderFns } from "./data-records-per-quarter.vue?vue&type=template&id=c5476446"
import script from "./data-records-per-quarter.vue?vue&type=script&lang=js"
export * from "./data-records-per-quarter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports